<app-loading [active]="loading.isLoading"/>
<app-message [active]="!!errorMsg" [message]="errorMsg"/>

@if (matches && !errorMsg) {
  <app-event-phase-matchlist [parentMatch]="matchIntern"
                             [matchesList]="matches"
                             [additionalHeight]="48"
                             [positionTop]="positionTop"
                             [showMouseOver]="true" [showGameNr]="true" [showColumnRound]="false"
                             [showDate]="false" [showTime]="false"
                             [grouping]="true" [groupRowsBy]="'matchReportBlock.blockIndex'"
                             [eventId]="matchIntern?.eventId"
  />
}
